<template>
                <div class="card card-body" v-if="contact">
                    <div class="row">
                        <div class="col-sm-5">Ansprechpartner</div>
                        <div class="col-sm-7 customer-data">{{ contact.name }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5">E-Mail-Adresse(n)</div>
                        <div class="col-sm-7 customer-data-ff">
                            <div v-for="email in emails"><a :href="'mailto:' + email">{{ email }}</a></div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5">Telefon</div>
                        <div class="col-sm-7 customer-data-ff">{{ contact.phone }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-5">Organisation</div>
                        <div class="col-sm-7 customer-data-ff">{{ contact.org }}</div>
                    </div>
                </div>
</template>

<script>
export default {
  props: ['contact'],
  computed: {
    emails () {
        return this.contact.email.split(',').map(email => {
            return email.trim();
        });
    }
  }
}
</script>